import React from "react";
import { makeStyles, TableCell } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  head: {
    textTransform: "uppercase",
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    padding: theme.spacing(3, 0, 3, 6),
    [theme.breakpoints.only("xs")]: {
      fontSize: 12,
      padding: theme.spacing(2, 4, 2, 4),
    },
  },
}));

type TableHeadItemProps = {
  children: React.ReactNode;
};

export default function TableHeadItem({ children }: TableHeadItemProps) {
  const classes = useStyles();
  return <TableCell className={classes.head}>{children}</TableCell>;
}
